var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M793 279.94c75.17 76.83 152 150.13 225.9 228.52-339.85-81-678.78-83.33-1018.12 1.91 138.79-151.55 294-294.66 438.7-443 21.17-21 42.38-41.93 63.22-63.24 5.32-5.43 8.89-5.5 14.08 0 9.93 10.44 20.42 20.34 30.68 30.46 12.66 15.23 27.37 28.65 42 41.6a1.6 1.6 0 000 .23c55.25 56.27 110.73 114.94 168 167.5l.6-.59-.53.65c2.11 6.71 7.78 9.86 13.05 13.57.92.93 1.9 1.86 2.79 2.82A94 94 0 00793 279.94z",
    fill: "#fdb202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M764 772.89C681.43 855.33 598.36 937.23 516.14 1020c-4.55 4.68-7.37 5.84-12.57.6-73-75.46-150.48-147.58-221.42-224.46 78.05-21.22 264.18-76.31 126.85-166C238.91 485.74 961.45 515.19 1023.23 512 935.7 600.75 849.56 685.68 764 772.89z",
    fill: "#0235d8"
  })));
}
export default SvgSh;